import DownloadDocumentFileRequestModelBase from '../_generated/modelBases/download-document-file-request-model-base';

export default class DownloadDocumentFileRequestModel extends DownloadDocumentFileRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
